import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck, ArrowRight, Lock, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const links = {
    pro: 'https://saludentuplato.shop/checkouts/cn/hWND5OfozIhBnCFy9jVk0xHu/es-ar?_r=AQABMGpfEzIECX6sr9bPdoFbe0SJLTU_94iqdWDDfKmK2xA&cart_link_id=Cld097Dk&preview_theme_id=151828791463',
    elite: 'https://saludentuplato.shop/checkouts/cn/hWND5PHNahg6wcWmGGbKSBP8/es-ar?_r=AQABr8TMGV5nFHdwVoJwy8q7_wpr_yHot56f8nhoaryLJ_w&cart_link_id=N0i4ish8&preview_theme_id=151828791463'
  };
  const ctaText = {
    pro: '→ SÍ, QUIERO EL MEGAPACK NUTRICIONISTA 360º',
    elite: '→ SÍ, QUIERO EL MEGAPACK NUTRICIONISTA 360º + SISTEMA CLÍNICO PRO ELITE™'
  };
  return <section id="comprar" className="px-3 py-10 bg-black" data-id="element-100">
      <div className="max-w-[680px] mx-auto" data-id="element-101">
        <FadeIn className="text-center mb-6" data-id="element-102">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-103">
            Elegí tu{' '}
            <span className="text-accent" data-id="element-104">Megapack Nutricionista 360º</span>
          </h2>
        </FadeIn>

        <div className="space-y-3 mb-5" data-id="element-105">
          {/* Card 1: Megapack */}
          <FadeIn delay={0.1} data-id="element-106">
            <div onClick={() => setSelected('pro')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,85,247,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-107">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-white/20 group-hover:border-accent/50'}`} data-id="element-108">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-109" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-110">
                <h3 className={`text-lg md:text-xl font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-111">
                  MEGAPACK NUTRICIONISTA 360º
                </h3>
              </div>

              <div className="text-right shrink-0" data-id="element-112">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-113">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-114">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Plus (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-115">
            <div onClick={() => setSelected('elite')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,85,247,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-116">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-117">
                <span className="bg-accent text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-118">
                  MÁS ELEGIDO
                </span>
                <span className="text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-accent/80" data-id="element-119">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-white/20'}`} data-id="element-120">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-121" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-122">
                <h3 className={`text-lg md:text-xl font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-123">
                  MEGAPACK NUTRICIONISTA 360º + SISTEMA CLÍNICO PRO ELITE™
                </h3>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-124">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-125">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-126">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-5" data-id="element-127">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-xl py-5 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center text-[16px]" data-id="element-128">
            {'\u2192 QUIERO MIS PROTOCOLOS CL\xCDNICOS\u2122 \u2696\uFE0F'}
          </motion.a>
          <p className="text-white/50 text-xs mt-3 italic" data-id="element-129">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} className="mb-10" data-id="element-130">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface border border-accent/25 rounded-lg py-3 px-4" data-id="element-131">
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-132">
              <Lock size={16} className="text-accent" data-id="element-133" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-134">
              <Zap size={16} className="text-accent" data-id="element-135" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-136">
              <ShieldCheck size={16} className="text-accent" data-id="element-137" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-138">
              <CreditCard size={16} className="text-accent" data-id="element-139" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>

        {/* Módulos */}
        <FadeIn delay={0.55} data-id="element-140">
          <div className="bg-surface border border-accent/25 rounded-xl p-4 mb-6" data-id="element-141">
            <h3 className="text-lg font-bold text-accent mb-3 text-center" data-id="element-142">
              📋 Qué incluye SISTEMA CLÍNICO PRO ELITE
            </h3>
            <ul className="space-y-2" data-id="element-143">
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-144">
                <span className="shrink-0" data-id="element-145">🧬</span>
                <span data-id="element-146">
                  <strong className="text-white" data-id="element-147">Módulo 1:</strong> Evaluación
                  Clínica con Criterio Profesional
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-148">
                <span className="shrink-0" data-id="element-149">🔢</span>
                <span data-id="element-150">
                  <strong className="text-white" data-id="element-151">Módulo 2:</strong> Qué Revisar
                  Primero Cuando el Paciente No Mejora
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-152">
                <span className="shrink-0" data-id="element-153">⚙️</span>
                <span data-id="element-154">
                  <strong className="text-white" data-id="element-155">Módulo 3:</strong> Intervención
                  Nutricional Según Síntomas y Contexto
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-156">
                <span className="shrink-0" data-id="element-157">🏅</span>
                <span data-id="element-158">
                  <strong className="text-white" data-id="element-159">Módulo 4:</strong> Seguimiento
                  Clínico y Ajustes Inteligentes
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-160">
                <span className="shrink-0" data-id="element-161">📝</span>
                <span data-id="element-162">
                  <strong className="text-white" data-id="element-163">Módulo 5:</strong> Errores
                  Clínicos Frecuentes en Consulta Nutricional
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-164">
                <span className="shrink-0" data-id="element-165">💊</span>
                <span data-id="element-166">
                  <strong className="text-white" data-id="element-167">Módulo 6:</strong> Resolución
                  de Casos Clínicos Frecuentes
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* Objections */}
        <FadeIn delay={0.6} data-id="element-168">
          <div className="grid md:grid-cols-3 gap-4" data-id="element-169">
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-170">
              <h4 className="font-bold text-accent mb-2" data-id="element-171">
                ¿Y si soy recién recibido?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-172">
                Te da la estructura clínica y seguridad que la facultad no te
                dio para tu primera consulta. Entrás con ventaja.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-173">
              <h4 className="font-bold text-accent mb-2" data-id="element-174">
                ¿Y si ya tengo experiencia?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-175">
                Te ahorra horas de armado de protocolos y te da un sistema
                pulido para escalar pacientes complejos sin quemarte la cabeza.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-176">
              <h4 className="font-bold text-accent mb-2" data-id="element-177">¿Y si no me sirve?</h4>
              <p className="text-white/70 text-sm" data-id="element-178">
                Tenés 7 días de garantía total. Si sentís que no te suma valor
                clínico, te devolvemos el dinero sin hacer preguntas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}